import { useMemo, useSyncExternalStore } from "react";
import { getChatSubscriptionStore } from "../stores/chatSubscriptionStore.js";
export function useChatListStore(styleId) {
    const store = getChatSubscriptionStore(styleId);
    const chats = useSyncExternalStore(store.subscribeChats, store.getChatsSnapshot);
    return useMemo(() => ({
        chats,
    }), [chats]);
}
